import React, { useCallback, useEffect, useState, useMemo } from 'react';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Button from '../../shared/components/ui/Button';
import Search from '../../shared/components/ui/Search';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import filter from '../../../modules/shared/assets/svg/filter.svg';
import PaginatedTable from '../../shared/components/layout/PaginatedTable';
import usersjson from '../static/data/Users.json';
import { transformData } from '../../super-admin/utils/transformData';
import { AddUser } from '../components/forms/AddUser';
import Modal from '../../shared/components/ui/Modal';
import {
  addUserStatic,
  createUser,
  deleteUser,
  deleteUserById,
  getAllDesignations,
  getAllRoles,
  getAllUsers,
  getUserById,
  handleCheckUserDelete,
  resendEmailInvites
} from '../services/api/implementation/impl';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  buildReturnToFromLocation,
  navigateWithReturn
} from '../../shared/navigation';
import { EditUser } from '../components/forms/EditUser';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { Sales } from './SalesList';
import { RateList } from './RateList';

import NoDataFound from '../components/layout/NoDataFound';
import PaginationComponent from '../../shared/components/PaginationComponent';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import Loader from '../../shared/components/ui/Loader';

const UsersList = () => {
  const userId = Cookies.get('userId');
  const queryClient = useQueryClient();

  /* 
    Hooks
  */
  const navigate = useNavigate();
  const location = useLocation();

  /* 
    Local state
  */
  const [OpenAddUser, setOpenAddUser] = useState(false);
  const [isOpenEditUser, setIsOpenEditUser] = useState(false);
  const [userStatic, setuserStatic] = useState(usersjson);
  const [searchQuery, setSearchQuery] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { collapsed } = useSidebar();
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [resetTrigger, setResetTrigger] = useState(0); // Increment to reset pagination
  const [viewManagerOpen, setViewManagerOpen] = useState(false);
  const [viewManagerUser, setViewManagerUser] = useState(null);
  const [viewManagerLoading, setViewManagerLoading] = useState(false);
  const [viewSalesExecOpen, setViewSalesExecOpen] = useState(false);
  const [viewSalesExecUser, setViewSalesExecUser] = useState(null);
  const [viewSalesExecLoading, setViewSalesExecLoading] = useState(false);

  /* 
    Event handlers
  */
  const handleToggleAddUser = () => {
    setOpenAddUser(!OpenAddUser);
  };

  const handleToggleEditUser = (id) => {
    setIsOpenEditUser(!isOpenEditUser);
  };

  const handleNavigateUser = (id) => {
    getUserbyid(id);
  };

  const handleResendInvite = async (id) => {
    try {
      // Fetch user details to get email
      const userData = await getUserById(parseInt(id));
      if (userData?.email) {
        resendInvite({ email: userData.email });
      }
    } catch (err) {
      console.error('Error fetching user for resend invite:', err);
      toast.error('Error fetching user details');
    }
  };

  const handleViewManager = async (id) => {
    setViewManagerLoading(true);
    setViewManagerOpen(true);
    try {
      const userData = await getUserById(parseInt(id), { full: true });
      setViewManagerUser(userData);
    } catch (err) {
      console.error('Error fetching user for view manager:', err);
      toast.error('Error loading user details');
      setViewManagerOpen(false);
    } finally {
      setViewManagerLoading(false);
    }
  };

  const handleViewSalesExec = async (id) => {
    setViewSalesExecLoading(true);
    setViewSalesExecOpen(true);
    try {
      const userData = await getUserById(parseInt(id), { full: true });
      setViewSalesExecUser(userData);
    } catch (err) {
      console.error('Error fetching user for view sales executives:', err);
      toast.error('Error loading user details');
      setViewSalesExecOpen(false);
    } finally {
      setViewSalesExecLoading(false);
    }
  };

  const handleDeleteUser = (userId) => {
    deleteUser(userId);
  };

  const usersDataFormat = [
    'id',
    'name',
    'email',
    'phone_number',
    'designation_name',
    'status',
    'invite',
    'actions'
  ];

  /* 
    Hook form
  */
  const { reset } = useForm();

  /* 
    Data fetching
   */
  const { data: roles } = useQuery({
    queryKey: ['roles'],
    queryFn: () => getAllRoles()
  });

  const { data: designations } = useQuery({
    queryKey: ['designations'],
    queryFn: () => getAllDesignations()
  });

  console.log({ roles });

  const { mutate: getUserbyid, isLoading: isLoadingUserbyIdMutation } = useMutation({
    mutationFn: (id) => getUserById(parseInt(id)),
    onSuccess: async (res) => {
      navigateWithReturn(navigate, `/builder/users/${res.id}`, {
        returnTo: buildReturnToFromLocation(location)
      });
      reset();
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || err?.message || 'Error creating get user by Id');
      console.error('Error creating new user by Id');
    }
  });

  // Track page view
  useEffect(() => {
    mixpanel.track('Users List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  //wriet useMutation for resendEmailInvites
  const { mutate: resendInvite } = useMutation({
    mutationFn: (payload) => resendEmailInvites(payload),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setIsSubmitting(false);
      console.log({ res });
      toast.success('Invite sent successfully');

      // Reset search and trigger pagination reset
      setSearchQuery('');
      setResetTrigger((prev) => prev + 1);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error sending invite');
      toast.error(err?.response?.data?.message || err?.message || 'Error sending invite');
    }
  });
  const handleSearchChange = useCallback((incomingQuery) => {
    setSearchQuery(incomingQuery);
  }, []);

  // Handle loading state changes from PaginatedTable
  const handleLoadingChange = useCallback((isLoading) => {
    setIsSubmitting(isLoading);
  }, []);

  /* 
    Data mutation
  */
  const { mutate, isLoading: isLoadingNewUserMutation } = useMutation({
    mutationFn: (newUser) => createUser(newUser),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      setOpenAddUser(false);
      toast.success('User created successfully');
      reset();

      // Reset search and trigger pagination reset
      setSearchQuery('');
      setResetTrigger((prev) => prev + 1);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating new user');
    }
  });

  // Transform function for PaginatedTable
  const transformUserData = useCallback(
    (users) => {
      if (!users || users.length === 0) return [];

      return users
        .slice() // make a shallow copy to avoid mutating original state
        .sort((a, b) => a.name?.localeCompare(b.name)) // sort by name alphabetically
        .map((item) => {
          const transformed = transformData(
            {
              ...item,
              designation_name: designations
                ?.filter((ele) => ele.id == item?.desgignation_id)
                ?.map((ele) => ele.name),
              status: item?.is_blocked ? 'Restricted' : 'Active',
              invite: `Invite ${item?.is_active}`
            },
            usersDataFormat
          );
          // Show View Manager button only for Sales Executives (Sales vertical + Low level)
          // Show View Sales Executive button only for Sales Managers (Sales vertical + Medium level)
          return {
            ...transformed,
            _showViewManager: item?.vertical === 'Sales' && item?.level === 'Low',
            _showViewSalesExec: item?.vertical === 'Sales' && item?.level === 'Medium'
          };
        });
    },
    [designations]
  );

  // onSubmit button function  for the Add to user
  const onSubmit_User = (data) => {
    mutate({ ...data });
  };

  //delete functions
  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckUserDelete(id),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      // Note: We can't access FilteredData here anymore, but we can get user info from the API response if needed
      const userName = res?.userName || 'user';
      const userRole = res?.userRole || null;
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: userName });
        setSelectedIds([parseInt(id)]);
      } else {
        setResData({ ...res, name: userName, role: parseInt(userRole) });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteUser(payload),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('User Deleted Successfully');
      setSelectedIds([]);
      setCanDelete(null);

      // Reset search and trigger pagination reset
      console.log('🔄 Resetting state and refetching users after delete...');
      setSearchQuery('');
      setResetTrigger((prev) => prev + 1);
      console.log('✅ Users refetch completed with fresh data');
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting users', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting users');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  return (
    <>
      <Loader isVisible={isSubmitting} />
      {/* Add builder form */}
      {OpenAddUser && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={56}
          name="Add User"
          onClose={handleToggleAddUser}>
          <AddUser
            isSubmitting={isSubmitting}
            onSubmit={onSubmit_User}
            users={userStatic}
            onClose={handleToggleAddUser}
          />
        </Modal>
      )}

      {/* Edit user form */}
      {isOpenEditUser && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={56}
          name="Edit builder"
          onClose={() => setIsOpenEditUser(false)}>
          <EditUser
            isSubmitting={isSubmitting}
            onSubmit={onSubmit_User}
            onClick={searchQuery}
            onClose={() => setIsOpenEditUser(false)}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this land'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          {resData?.role === 1 ? (
            <div className="flex flex-col justify-center align-center ">
              <p className="text-center">Cannot delete Admin</p>
            </div>
          ) : (
            <div className="flex flex-col justify-center align-center ">
              <p className="text-center">
                Looks like this user has dependencies, please delete following{' '}
                {resData?.role === 2
                  ? 'tasks, subTasks and change requests'
                  : resData?.role === 3
                    ? 'leads'
                    : 'tasks, subTasks, change requests and leads'}{' '}
                to proceed
              </p>
              <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
                {resData &&
                  resData?.reason?.map((r, index) => (
                    <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                      {index + 1}.{r}
                      {index < resData.reason.length - 1 ? ', ' : ''}
                    </span>
                  ))}
              </div>
            </div>
          )}
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'user'}
            onClose={() => setCanDelete(null)}
            data={[]}
            type={'user'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {/* View Manager modal */}
      {viewManagerOpen && (
        <Modal
          isDirty={false}
          confirmOnClose={false}
          name="View Manager"
          onClose={() => {
            setViewManagerOpen(false);
            setViewManagerUser(null);
          }}
          width={45}>
          <div className="flex flex-col gap-4 p-2">
            {viewManagerLoading ? (
              <div className="flex justify-center items-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#346C75]"></div>
                <span className="ml-2 text-gray-600">Loading...</span>
              </div>
            ) : viewManagerUser ? (
              <>
                {viewManagerUser?.userProjectMapping?.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border border-stone-200 rounded-lg overflow-hidden">
                      <thead className="bg-stone-100">
                        <tr>
                          <th className="text-left px-4 py-3 font-medium text-gray-700">Project Name</th>
                          <th className="text-left px-4 py-3 font-medium text-gray-700">Manager Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewManagerUser.userProjectMapping.map((mapping) => {
                          const project = mapping?.project ?? mapping;
                          const projectId = project?.id ?? mapping?.project_id;
                          const projectName = project?.displayName || project?.name || '—';
                          const managerEntry = viewManagerUser?.userManager?.find(
                            (m) => Number(m?.project_id) === Number(projectId)
                          );
                          const managerName =
                            managerEntry?.manager?.name ?? managerEntry?.manager_name ?? '—';
                          return (
                            <tr key={projectId} className="border-b border-stone-100 hover:bg-stone-50">
                              <td className="px-4 py-3 text-gray-800">{projectName}</td>
                              <td className="px-4 py-3 text-gray-800">{managerName}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-center text-gray-500 py-6">No projects assigned to this user.</p>
                )}
              </>
            ) : (
              <p className="text-center text-gray-500 py-6">No data available.</p>
            )}
          </div>
        </Modal>
      )}

      {/* View Team modal - for Sales Managers (vertical Sales, level Medium) */}
      {viewSalesExecOpen && (
        <Modal
          isDirty={false}
          confirmOnClose={false}
          name="View Team"
          onClose={() => {
            setViewSalesExecOpen(false);
            setViewSalesExecUser(null);
          }}
          width={45}>
          <div className="flex flex-col gap-4 p-2">
            {viewSalesExecLoading ? (
              <div className="flex justify-center items-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#346C75]"></div>
                <span className="ml-2 text-gray-600">Loading...</span>
              </div>
            ) : viewSalesExecUser ? (
              (() => {
                const projectIdToName = {};
                (viewSalesExecUser?.userProjectMapping || []).forEach((m) => {
                  const project = m?.project ?? m;
                  const id = project?.id ?? m?.project_id;
                  if (id != null) projectIdToName[id] = project?.displayName || project?.name || `Project ${id}`;
                });
                const byProject = {};
                (viewSalesExecUser?.manager || []).forEach((entry) => {
                  const projectId = entry?.project_id;
                  const name = entry?.user?.name;
                  if (projectId == null || !name) return;
                  const projectNameFromEntry = entry?.project?.name ?? entry?.project?.displayName;
                  if (!byProject[projectId]) {
                    byProject[projectId] = {
                      name: projectNameFromEntry ?? projectIdToName[projectId] ?? `Project ${projectId}`,
                      userIds: new Set(),
                      names: []
                    };
                  }
                  if (byProject[projectId].userIds.has(entry.user_id)) return;
                  byProject[projectId].userIds.add(entry.user_id);
                  byProject[projectId].names.push(name);
                });
                const rows = Object.entries(byProject);
                return rows.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border border-stone-200 rounded-lg overflow-hidden">
                      <thead className="bg-stone-100">
                        <tr>
                          <th className="text-left px-4 py-3 font-medium text-gray-700">Project Name</th>
                          <th className="text-left px-4 py-3 font-medium text-gray-700">Team</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map(([projectId, { name: projectName, names }]) => (
                          <tr key={projectId} className="border-b border-stone-100 hover:bg-stone-50">
                            <td className="px-4 py-3 text-gray-800">{projectName}</td>
                            <td className="px-4 py-3 text-gray-800">{names.join(', ')}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-center text-gray-500 py-6">No team members assigned to this manager.</p>
                );
              })()
            ) : (
              <p className="text-center text-gray-500 py-6">No data available.</p>
            )}
          </div>
        </Modal>
      )}

      <Layout>
        {/* Header */}
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <Header data={{ name: 'Users' }} />
        </div>

        <div className={`transition-all duration-300 ease-in-out ${collapsed ? 'ml-[1vw]' : ''}`}>
          {/* Main content */}
          <div
            className={`flex items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm z-[10] transition-all duration-300 ease-in-out ${
              collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
            }`}>
            {/* Pass searchQuery and handleSearchChange as props to Search component */}
            <Search onChange={handleSearchChange} query={searchQuery} />
            <div className="flex gap-5 cursor-pointer">
              <div>{/* <img className="" src={filter} alt="" /> */}</div>
              {/* <Button displayType={"secondary"} onClick={()=>navigate("/builder/users/roles")} children={'Manage Roles'}  /> */}
              <Button onClick={handleToggleAddUser}>Add User</Button>
            </div>
          </div>

          {/* Grid */}
          <GridWrapper width={100}>
            <div className="mt-[11rem] h-[calc(100vh-15rem)] min-h-[20rem] relative">
              <PaginatedTable
                queryKey="users"
                queryFn={getAllUsers}
                pageSize={30}
                transformData={transformUserData}
                searchQuery={searchQuery}
                resetTrigger={resetTrigger}
                onLoadingChange={handleLoadingChange}
                headers={['Name', 'Email', 'Phone', 'Designation', 'Status', 'Invite', 'Actions']}
                identifier={'id'}
                onEdit={handleToggleEditUser}
                handleRowClick={handleNavigateUser}
                onResendInvite={(id) => handleResendInvite(id)}
                onViewManager={handleViewManager}
                onViewSalesExec={handleViewSalesExec}
                isEditEnable={false}
                isDeleteEnable={true}
                onDelete={handleCheckDelete}
              />
            </div>
          </GridWrapper>
        </div>
      </Layout>
    </>
  );
};

export default UsersList;
